import { Errors, Photo, Steps } from "@/@types";

export type State = {
    photo: Photo | null;
    step: Steps;
    isLoading: boolean,
    returnUrl: string | undefined,
    error: Errors | undefined,
    isLoadingDocument: boolean,
    document: Photo | null,
    sessionType: string | null
}

export const state: State = {
    photo: null,
    step: Steps.Guidelines,
    isLoading: false,
    returnUrl: undefined,
    error: undefined,
    isLoadingDocument: false,
    document: null,
    sessionType: "photo"
}
